import React, { useEffect, useRef } from "react";
import { getOverlayGroups } from "../hooks/keyboardShortcutRegistry";

const overlayStyle = {
  position: "fixed",
  inset: 0,
  zIndex: 9999,
  background: "rgba(0,0,0,0.85)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backdropFilter: "blur(4px)",
};

const panelStyle = {
  background: "#1e293b",
  border: "1px solid #475569",
  borderRadius: 16,
  padding: "32px 40px",
  maxWidth: 800,
  maxHeight: "85vh",
  width: "90vw",
  overflowY: "auto",
  color: "#e2e8f0",
  fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
};

const titleStyle = {
  fontSize: "1.4em",
  fontWeight: 700,
  textAlign: "center",
  marginBottom: 4,
  color: "#3b82f6",
};

const subtitleStyle = {
  textAlign: "center",
  fontSize: "0.85em",
  color: "#94a3b8",
  marginBottom: 24,
};

const groupTitleStyle = {
  fontSize: "0.75em",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.5px",
  color: "#94a3b8",
  borderBottom: "1px solid #334155",
  paddingBottom: 6,
  marginBottom: 8,
  marginTop: 20,
};

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "0 32px",
};

const rowStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "4px 0",
  fontSize: "0.9em",
};

const kbdStyle = {
  display: "inline-block",
  background: "#334155",
  border: "1px solid #475569",
  borderRadius: 4,
  padding: "1px 8px",
  fontFamily: "'SF Mono', 'Fira Code', monospace",
  fontSize: "0.85em",
  fontWeight: 600,
  color: "#3b82f6",
  minWidth: 28,
  textAlign: "center",
};

const KeyboardShortcutsOverlay = ({ visible, onClose, layout }) => {
  const panelRef = useRef(null);

  useEffect(() => {
    if (!visible) return;
    const handleKey = (e) => {
      if (e.keyCode === 27 || e.keyCode === 112) {
        e.preventDefault();
        e.stopPropagation();
        onClose();
      }
    };
    window.addEventListener("keydown", handleKey, true);
    panelRef.current?.focus();
    return () => window.removeEventListener("keydown", handleKey, true);
  }, [visible, onClose]);

  if (!visible) return null;

  const layoutLabel = layout === "restaurant" ? "Restaurant" : "SuperMarket";
  const groups = getOverlayGroups(layout);

  return (
    <div style={overlayStyle} onClick={onClose}>
      <div
        ref={panelRef}
        style={panelStyle}
        role="dialog"
        aria-modal="true"
        aria-label="Keyboard shortcuts"
        tabIndex={-1}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={titleStyle}>Keyboard Shortcuts — {layoutLabel}</div>
        <div style={subtitleStyle}>Press F1 or Esc to close</div>
        <div style={gridStyle}>
          {groups.map((group) => (
            <div key={group.title}>
              <div style={groupTitleStyle}>{group.title}</div>
              {group.items.map((item) => (
                <div key={`${item.label}-${item.description}`} style={rowStyle}>
                  <span style={{ color: "#cbd5e1" }}>{item.description}</span>
                  <span style={kbdStyle}>{item.label}</span>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default KeyboardShortcutsOverlay;
